<div
        *ngIf="column.headerHtml; else basic"
        [innerHTML]="column.headerHtml"
        [matTooltip]="column.headerInfo"
></div>
<ng-template #basic>
    <div [matTooltip]="column.headerInfo">
        {{computeHeaderLabel(column)}}
    </div>
</ng-template>